<template>
  <div class="loading">
    <span></span>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'Loading'
})
export default class Loading extends Vue {}
</script>

<style lang="scss" scoped>
.loading {
  top: 0;
  left: 0;
  z-index: 101;
  height: 100%;
  width: 100%;
  background-color: $backgroundLogo;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  span {
    display: block;
    background-color: #0000;
    width: 60px;
    height: 60px;
    margin: 0 auto;
    border: 3px solid transparent;
    border-top-color: $green;
    border-bottom-color: $green;
    border-radius: 50%;
    animation: spin ease 1000ms infinite;
  }
}
</style>
